import { ListItem, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface ChangesPreviewItem {
  id: string;
  title?: string;
  currentValue?: string;
  newValue?: string;
}

export interface ChangesPreviewProps {
  items: ChangesPreviewItem[];
}

export const ChangesPreview = ({ items }: ChangesPreviewProps) => {
  const { t } = useTranslation();
  const getCaptionSlot = (item: ChangesPreviewItem) => {
    if (item.newValue === undefined) return <span>{item.currentValue}</span>;
    if (item.newValue === item.currentValue) return <span>{item.currentValue}</span>;
    return (
      <Stack direction={"horizontal"} gap={"xs"} className={"font-semibold"}>
        {item.currentValue && (
          <>
            <span className={"line-through"}>{item.currentValue}</span>
            <span>→</span>
          </>
        )}
        <span>{item.newValue || "-"}</span>
      </Stack>
    );
  };

  return (
    <>
      {items.map((item, index) => (
        <ListItem
          key={`${index}`}
          preTitle={item.title}
          captionSlot={getCaptionSlot(item)}
          valueSlot={
            <>
              {item.newValue !== undefined && item.newValue != item.currentValue && (
                <Text className={"font-semibold text-warning"}>{t("common:changed")}</Text>
              )}
            </>
          }
        />
      ))}
    </>
  );
};
